@let errModal = errorState.errorModal();

<div class="mainWrapper">
  <app-top-nav></app-top-nav>

  <div class="mobileOverlay" [style.display]="ui.mobileOverlayVisible() ? 'block' : 'none'" (click)="ui.handleMobileOverlayClick()"></div>
  <div class="galleryOverlay"></div>

  <div class="contentWrapper landingContentWrapper">
    <main class="appContent landingAppContent">
      <app-sidebar></app-sidebar>
      <div class="getMyReport">
        <app-spinner-overlay></app-spinner-overlay>
        <div class="errorOverlay" [style.display]="errModal.visible ? 'block' : 'none'"></div>
        <div id="background">
          <div class="betaRibbon" style="display:none"><span>BETA</span></div>
          <div id="container">
            <app-user-settings-modal></app-user-settings-modal>
            <app-error-modal></app-error-modal>
            <app-download-list></app-download-list>

            <app-function-picker>
              <app-parameter-form step2></app-parameter-form>
            </app-function-picker>
          </div>
        </div>
        <div class="settingsOverlay" [style.display]="ui.settingsOpen() ? 'block' : 'none'" (click)="ui.closeSettings()"></div>
      </div>
    </main>
  </div>
</div>
